module.exports = __webpack_public_path__ + "static/media/USDT.a440d4b5.png";